import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';

import { ListItem } from '../../../shared/list-confirmation/model/list-item';

import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { EventTypes } from './../../../shared/EventTypes';

import { PaymentFederalTaxes } from './../models/payment-federal-taxes';

import { PaymentFederalTaxesEventType } from './../payment-federal-taxes.event.type';
import { PaymentFederalTaxesService } from './../payment-federal-taxes.service';

@Component({
	selector: 'app-payment-result-gps',
	templateUrl: './payment-result-gps.component.html',
	styleUrls: ['./payment-result-gps.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PaymentResultGpsComponent implements OnInit, OnDestroy {

	@Input() paymentData: PaymentFederalTaxes;

	public form: FormGroup;
	private view = '[data-component="payment-result-gps"]';
	private today: number = Date.now();
	private viewHeight = 0;

	active = false;
	hasSubimited = false;
	confirmList: Array<ListItem> = [];

	imagesTax: Array<string> = [
		'assets/imgs/dashboard/logo-inss.png'
	];
	descriptionTax: String = `Ministério da Previdência e Assistência Social - MPAS <br>
	Instituto Nacional do Seguro Social - INSS <br>
	GPS (Guia da Previdência Social)`;

	constructor(private paymentService: PaymentFederalTaxesService) {	}

	ngOnInit() {
		AppEventDispatcher.listen( PaymentFederalTaxesEventType.STEPS_GPS.RESULT_GPS, () => {
			this.active = true;
			this.show();
		});
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				this.viewHeight = containerHeight;

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	hide() {
		this.removeListeners();

		TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener( PaymentFederalTaxesEventType.STEPS_GPS.RESULT_GPS );
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/payment-result-gps/payment-result-gps.component.ts